import {useEffect} from 'react';

const useTitle = (title: string) => {
  useEffect(() => {
    if (document) document.title = `${title} | DasAR App`;
  }, [title]);
};

export default useTitle;
